export enum Module {
  BrokerPortal = 'broker-portal',
  MiddleOffice = 'middle-office',
}
